import { IScrollState } from './types';

const generateHours = (): Array<string> => {
  const hours = [];
  for (let i = 0; i < 36; i++) {
    const hour = (i % 24).toString().padStart(2, '0');
    hours.push(`${hour}:00`, `${hour}:30`);
  }

  hours.push('12:00');
  return hours;
};

const hours = generateHours();

const ALL_GROUPS_VALUE = 0;

export { hours, ALL_GROUPS_VALUE };

export const DEFAULT_SCROLL_STATE: IScrollState = {
  isScrolling: false,
  clientX: 0,
  clientY: 0,
  startX: 0,
  totalDistance: 0,
  isAtEdge: false,
  edgeStartX: 0,
  readyToSwitchDay: false,
  edgeSide: null,
};
